// extracted by mini-css-extract-plugin
export default {"dailyScoopContent":"upTrending_dailyScoopContent__5McIp","titleWrapper":"upTrending_titleWrapper__rTYW7","title":"upTrending_title__j7C3q","divider":"upTrending_divider__ptaB0"};